export default "__VITE_ASSET__1ff1407e__"